<!--Scroll to top-->
<div [ngClass]="{'show-scrollTop': windowScrolled}" class="scroll-to-top">
  <button (click)="scrollToTop()" aria-label="Scroll to top" mat-fab>
    <img alt="Scroll to top" class="turn-icon fill-svg-white" src="../../../assets/arrow-right-black-18dp.svg">
  </button>
</div>
